import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, FileDown, Stethoscope, Shield } from 'lucide-react';
export function HeroSection() {
  return <section className="px-4 max-w-5xl mx-auto text-center pt-3 md:pt-16 pb-6 md:pb-16" data-id="element-50">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="inline-flex bg-brand-green/10 text-brand-green rounded-full font-bold border border-brand-green/30 text-xs md:text-sm shadow-sm py-1 md:py-1.5 px-3 md:px-4 gap-1.5 mb-3 md:mb-6 items-center" data-id="element-51">
        <span data-id="element-52">🐾</span> TU MANUAL DIGITAL
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-5xl text-[22px] leading-[1.15] tracking-tight text-balance text-brand-dark font-extrabold mb-3 md:mb-5" data-id="element-53">
        Estudiaste años para atender animales. Pero terminás el día escribiendo
        lo mismo que escribiste ayer.
      </motion.h1>

      <motion.div initial={{
      opacity: 0,
      scale: 0.92,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.15
    }} className="flex justify-center mb-3 md:my-6" data-id="element-54">
        <img src="https://cdn.magicpatterns.com/uploads/rRqNEZ6C6pC8gKS7kQ4ETY/ChatGPT_Image_31_may_2026__18_37_13-removebg-preview.png" alt="Consultorio en orden - Kit clínico veterinario: 6 tomos + 6 bonos" className="w-full max-w-[200px] md:max-w-2xl drop-shadow-[0_25px_45px_rgba(20,83,45,0.25)]" data-id="element-55" />
      </motion.div>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.25
    }} className="md:text-2xl text-sm text-brand-muted font-medium mb-4 md:mb-8 max-w-3xl mx-auto leading-snug md:leading-relaxed" data-id="element-56">
        Consultorio en orden es el kit de documentación clínica que te ahorra
        horas de trabajo por semana, desde el primer día que lo descargás.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="flex flex-col items-center mb-8 md:mb-12" data-id="element-57">
        <a href="#pricing" className="group relative inline-flex px-6 py-3.5 md:py-5 md:px-8 text-base md:text-xl font-black text-brand-white bg-brand-green rounded-xl overflow-hidden transition-all hover:scale-105 hover:bg-brand-green-hover shadow-[0_10px_40px_rgba(22,101,52,0.3)] w-full max-w-md items-center justify-center mb-3 md:mb-5" data-id="element-58">
          <span className="relative z-10 text-base md:text-[20px]" data-id="element-59">
            → QUIERO MI KIT AHORA
          </span>
          <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-60" />
        </a>

        <div className="text-[11px] md:text-sm text-brand-muted font-medium space-y-1 md:space-y-2" data-id="element-61">
          <p data-id="element-62">Pago único · Acceso y descarga inmediata · Sin suscripción</p>
          <p className="text-brand-green font-bold flex items-center justify-center gap-1.5" data-id="element-63">
            <Shield size={14} data-id="element-64" /> Garantía de 7 días — si no te sirve, te
            devolvemos el 100%
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 text-xs md:text-sm font-bold text-brand-muted mb-4 md:mb-12 justify-center" data-id="element-65">
        <div className="flex items-center justify-center gap-1.5 bg-brand-white px-3 py-2 md:py-2.5 rounded-lg border border-brand-border shadow-sm" data-id="element-66">
          <FileText size={14} className="text-brand-gold" data-id="element-67" /> 100% PDF
        </div>
        <div className="flex items-center justify-center gap-1.5 bg-brand-white px-3 py-2 md:py-2.5 rounded-lg border border-brand-border shadow-sm" data-id="element-68">
          <Zap size={14} className="text-brand-gold" data-id="element-69" /> Acceso al instante
        </div>
        <div className="flex items-center justify-center gap-1.5 bg-brand-white px-3 py-2 md:py-2.5 rounded-lg border border-brand-border shadow-sm" data-id="element-70">
          <FileDown size={14} className="text-brand-gold" data-id="element-71" /> PDF + Word
        </div>
        <div className="flex items-center justify-center gap-1.5 bg-brand-white px-3 py-2 md:py-2.5 rounded-lg border border-brand-border shadow-sm" data-id="element-72">
          <Stethoscope size={14} className="text-brand-gold" data-id="element-73" /> Para clínicos
        </div>
      </motion.div>
    </section>;
}